<template lang="pug">
form-item-wrapper(v-bind="$attrs", v-on="$listeners", :rules="myRules")
  component.vf-custom-inject(:is="computeVue", v-bind="$attrs", v-on="$listeners", @rules:update="onCustomUpdateRules")
  div(v-html="vueStyle")
</template>
<script>
import VForm from "../utils/vform.js";
import BaseVue from "./baseVue.vue";
import axios from "@/CommonDP/utils/request";
import { fromPairs } from "lodash";
import { importScript } from "@/CommonDP/utils/index.js";
import { computedField } from "../utils/method.js";

const {
  VFormSDK: { emitter, fieldMixin }
} = VForm;
export default {
  components: { FormItemWrapper: VForm.VFormSDK.FormItemWrapper },
  mixins: [emitter, fieldMixin],
  inheritAttrs: false,
  data() {
    return {
      rules: []
    };
  },
  computed: {
    ...fromPairs(
      ["field", "parentWidget", "parentList", "indexOfParentList", "designer", "designState", "subFormRowIndex", "subFormColIndex", "subFormRowId"].map((key) => [
        key,
        function () {
          return this.$attrs[key];
        }
      ])
    ),
    myRules() {
      return [...this.rules];
    },
    vueStyle() {
      return `<style>${this.$attrs.field.options.vueStyle}</style>`;
    },
    computeVue() {
      const {
        $attrs: {
          field: {
            options: { vueTemplate, vueScript, externalScripts = [] }
          }
        }
      } = this;
      return async () => {
        const resList = (externalScripts || []).map((str) => importScript(str));
        await Promise.all(resList);
        const options = new Function("axios", "computedField", `return ${vueScript}`)(axios, computedField);
        return {
          ...options,
          extends: BaseVue,
          template: vueTemplate
        };
      };
    }
  },
  created() {
    this.registerToRefList();
  },
  methods: {
    onCustomUpdateRules(rules) {
      this.rules = rules;
    }
  }
};
</script>
